"use strict"

import { Data } from '@/lib/core/components/data/data'

export class TerrenosLotesDM extends Data {
  constructor({ form, updateStore, Logic, component }) {
    super({ form, module: 'data', dataId: 'terrenos_lotes', updateStore, Logic, component, originClass: TerrenosLotesDM })
  }
  build = async ({ register, fields }) => {
    this.form.build({ register, fields })
    return this
  }
  async getRegister({ _id, project }) {
    await this
      .form
      .readRegister({
        query: { _id },
        project
      })
    return this
  }
}